var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.68 3.475c-.116-.775-.422-1.543-.758-2.261-.309-.66-.915-1.027-1.693-1.07-.665-.036-1.33-.131-1.995-.133C13.1-.002 8.968-.005 4.835.01c-.753.003-1.508.083-2.257.166-.667.073-1.16.426-1.506.996-.4.657-.64 1.366-.75 2.114-.389 2.634-.447 5.276-.057 7.91.119.803.394 1.602.719 2.353a1.928 1.928 0 0 0 1.59 1.174c.574.068 1.152.117 1.73.131 2.267.055 4.535.093 7.213.145 2.097-.058 4.602-.119 7.107-.204.758-.026 1.514-.106 2.051-.753.432-.52.7-1.113.839-1.757.628-2.926.607-5.872.166-8.811ZM8.842 11.332v-7.79l6.167 3.906-6.167 3.884Z","fillRule":"evenodd"}));
}

Youtube.defaultProps = {"viewBox":"0 0 22 15"};

module.exports = Youtube;

Youtube.default = Youtube;
